import clsx from "clsx";
import { PropsWithChildren, useMemo } from "react";
import { FieldPath, useFormContext } from "react-hook-form";

type Props<T> = PropsWithChildren<{
  name: FieldPath<T>;
  value: number;
  defaultChecked?: boolean;
}>;

const CheckboxWithLabel = <T,>(props: Props<T>) => {
  const { name, value, defaultChecked, children } = props;
  const { register } = useFormContext<T>();
  const checkboxId = useMemo<string>(() => `${name}_${value}`, [name, value]);

  return (
    <div className="inline-flex gap-4 items-center">
      <label
        className="relative flex items-center rounded-full cursor-pointer"
        htmlFor={name}
      >
        <input
          type="checkbox"
          className={clsx(
            "peer appearance-none",
            "relative h-[20px] w-[20px] rounded-xs border border-secondary transition-all cursor-pointer",
            "checked:bg-gray-950",
          )}
          value={value}
          id={checkboxId}
          defaultChecked={defaultChecked}
          {...register(name)}
        />
        <span
          className={clsx(
            "absolute pointer-events-none top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 w-[20px] h-[20px]",
            "opacity-0", // 非選択状態
            "peer-checked:opacity-100", // 選択状態
          )}
        >
          <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.33021 13.2293L3.85521 9.75426L2.67188 10.9293L7.33021 15.5876L17.3302 5.5876L16.1552 4.4126L7.33021 13.2293Z"
              fill="white"
            />
          </svg>
        </span>
      </label>
      <label
        className="text-sm text-primary cursor-pointer select-none"
        htmlFor={checkboxId}
      >
        {children}
      </label>
    </div>
  );
};
export default CheckboxWithLabel;
